import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './yuanniuniu.jsx'; // Explicitly import the .jsx file
import reportWebVitals from './reportWebVitals';
import { startTracking } from './utils/tracker';

startTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
